// extracted by mini-css-extract-plugin
module.exports = {"column":"AdditionalInformation_column__Ci6w2","articles":"AdditionalInformation_articles__Q5csC"};